import { render, staticRenderFns } from "./AiInvoiceAccountingValueTypeAdd.vue?vue&type=template&id=22e3b7d1&"
import script from "./AiInvoiceAccountingValueTypeAdd.vue?vue&type=script&lang=js&"
export * from "./AiInvoiceAccountingValueTypeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports